import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class ProductAnalysisGroup2 extends BaseEntity {

  productAnalysisGroup2Code : string;
  name                      : string;
  rank                      : string;
   
}